/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React, { memo } from "react";

import { ConnectedVehicleCardCollectionLite } from "@at/connected-vehicle-card-collection-lite/lib/connected-vehicle-card-collection-lite";
import { VehicleTypes, LeaseType } from "@at/design-system-patterns";
import { Channel } from "@at/sauron-platform-core";
import { usePageState } from "@at/sauron-platform-core/lib/page/page-state.hoc";

import { ListingType } from "../../../__generated__/fed-graphql-types";
import {
  AdvertisingLocation,
  Sort,
  LeaseContractType,
} from "../../../__generated__/graphql-types";

const LeasingStripComponent = () => {
  const {
    state: { channel },
  } = usePageState();

  const leaseContractType =
    channel === Channel.vans
      ? LeaseContractType.business
      : LeaseContractType.personal;

  const leaseType =
    channel === Channel.vans ? LeaseType.BUSINESS : LeaseType.PERSONAL;

  const advertisingLocations =
    channel === Channel.vans
      ? [AdvertisingLocation.at_lease_new_van]
      : [
          AdvertisingLocation.at_lease_new_car,
          AdvertisingLocation.at_lease_virtual_car,
        ];

  return (
    <div id={"vehicle-strip"}>
      <ConnectedVehicleCardCollectionLite
        channel={channel}
        vehicleType={VehicleTypes.LEASE}
        gqlQueryVars={{
          leaseOption: "cheapest",
          advertisingLocations: advertisingLocations,
          hasImages: true,
          sort: Sort.LEASE_RELEVANCE,
          limit: 4,
          showSpecification: true,
          leaseContractType,
        }}
        showroomLiteProperties={{
          headingText: `You may also like`,
          layout: "carousel",
          carouselProperties: {
            showArrows: true,
            showPips: false,
            allowSlideOverlap: false,
          },
        }}
        additionalVehicleCardData={{
          hideVehicleDetails: true,
          leaseType,
          trackingData: {
            label: ListingType.YOU_MAY_ALSO_LIKE,
          },
        }}
      />
    </div>
  );
};

export default memo(LeasingStripComponent);
